import {useEffect, useRef, useState} from 'react'

export const useIsScrolledPast = (threshold = 100) => {
  const [isScrolledPast, setIsScrolledPast] = useState(false)

  // Pending requestAnimationFrame id, prevents scheduling multiple calls per frame
  const frameId = useRef<number | null>(null)

  useEffect(() => {
    // This runs inside requestAnimationFrame (max once per frame)
    const update = () => {
      setIsScrolledPast(window.scrollY > threshold)
      frameId.current = null
    }

    // Scroll event fires many times → we throttle it via requestAnimationFrame
    const handleScroll = () => {
      if (frameId.current === null) {
        frameId.current = window.requestAnimationFrame(update)
      }
    }

    // Sync with the initial position (e.g. page restored mid-scroll)
    update()

    window.addEventListener('scroll', handleScroll, {passive: true})
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (frameId.current !== null) {
        window.cancelAnimationFrame(frameId.current)
        frameId.current = null
      }
    }
  }, [threshold])

  return isScrolledPast
}
